import { styled } from '@mui/system';
import theme from '../../theme';
import { Props } from '.';

export const Container = styled('div')({
    width: 'auto',
    display: 'inline-block',
    padding: '10px'
});

export const Row = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
});

export const ProgressContainer = styled('div')(({ value }: Props) => ({
    position: 'relative',
    border: `0.5px solid ${
        value && value > 85
            ? theme.color.brightGreen
            : value && value > 25
              ? theme.color.alloyOrange
              : theme.color.orangyRed
    }`,
    width: 100,
    height: 34,
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex'
}));

export const Progress = styled('div')(({ value }: Props) => ({
    width: `${((value || 1) / 100) * 100}px`,
    height: 34,
    position: 'absolute',
    left: 0,
    right: 0,
    background:
        value && value < 25
            ? theme.color.darkMintRed
            : value && value < 85
              ? theme.color.darkMintYellow
              : theme.color.darkMintGreen
}));
